import React from 'react';

interface Props {
  className?: string;
}
export default function ArrowIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 14.3789L5.6902 8.14845C5.48975 7.95052 5.16476 7.95052 4.9643 8.14845L4.15034 8.95217C3.94989 9.15011 3.94989 9.47101 4.15034 9.66894L11.2741 16.7031C11.675 17.099 12.325 17.099 12.7259 16.7031L19.8497 9.66894C20.0501 9.47101 20.0501 9.15011 19.8497 8.95218L19.0357 8.14845C18.8352 7.95052 18.5102 7.95052 18.3098 8.14845L12 14.3789Z"
        fill="currentColor"
      />
    </svg>
  );
}
